<template functional>
    <button
        @click="() => parent.$listeners.itemClick && parent.$listeners.itemClick(props)"
        :class="{ 'nav_slider-item': true,  btn: true,  'is-active': props.isActive }"
    >
        {{ props.label }}
    </button>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: true,
            },
            id: {
                type: [String, Number],
                required: true,
            },
            isActive: {
                type: Boolean,
                default: false,
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/mobile/components/NavSlider/NavSliderItem.vue